import { FC } from "react";
import { Controller } from "react-hook-form";
import { FormFeedback, InputGroup } from "reactstrap";
import { DatePickerProps } from "./DatePicker.constant";

import { Turkish } from "flatpickr/dist/l10n/tr.js";
import "flatpickr/dist/themes/material_green.css";
import Flatpickr from "react-flatpickr";

const DatePicker: FC<DatePickerProps> = ({
  control,
  name,
  value,
  defaultValue,
  placeholder,
  invalid,
  onChangeHandler,
  error,
  enableTime = false,
}) => {
  const errorStyles = {
    border: "1px solid #fea19e",
    borderRadius: "0.25rem",
    marginLeft: 0,
    borderTopLeftRadius: 0,
    borderBottomLeftRadius: 0,
  };

  return (
    <Controller
      control={control}
      defaultValue={defaultValue}
      name={name}
      render={({ field: { onChange, ref, ...fieldProps } }) => {
        return (
          <>
            <InputGroup
              style={invalid ? errorStyles : {}}
              ref={ref}
              className="datepicker-range"
            >
              <Flatpickr
                className="form-control d-block ml-1"
                options={{
                  locale: { ...Turkish },
                  altFormat: enableTime ? "F j, Y H:i" : "F j, Y",
                  dateFormat: enableTime ? "Y-m-d H:i" : "Y-m-d",
                  placeholder: placeholder,
                  defaultValue: defaultValue,
                  value: value,
                  altInput: true,
                  time_24hr: true,
                  enableTime: enableTime,
                }}
                {...fieldProps}
                onChange={(currentdateString: string) => {
                  if (currentdateString.length > 0) {
                    let selectedDate = currentdateString[0];
                    onChange(selectedDate);
                    onChangeHandler && onChangeHandler(selectedDate);
                  } else {
                    onChange(new Date());
                    onChangeHandler && onChangeHandler(new Date());
                  }
                }}
              />
              <div className="input-group-text" id="date1">
                <i className="bx bx-calendar-event"></i>
              </div>
            </InputGroup>

            {!!error && error ? (
              <FormFeedback style={{ display: "block" }} type="invalid">
                {error}
              </FormFeedback>
            ) : (
              <div style={{ height: "22.5px", width: "100%" }}> </div>
            )}
          </>
        );
      }}
    />
  );
};

export default DatePicker;
